import { BtFileObject } from "../../../models";

export type DuplicateFileNames = {
  // Names that already belong to a document in the project.
  inProject: string[];
  // Names picked more than once in the same import.
  inBatch: string[];
};

const isRealDocument = (doc: any) =>
  !!(
    doc?.driveItemId ||
    doc?.metadata?.driveItemId ||
    doc?.latestVersion?.metadata?.driveItemId
  ) || (doc?.versionCount ?? 0) > 1;

export const findDuplicateFileNames = (
  files: BtFileObject[] = [],
  projectDocuments: any[] = []
): DuplicateFileNames => {
  const newDocumentNames = files
    .filter((file) => !file.isNewVersion)
    .map((file) => file.fileName)
    .filter((name) => !!name);

  const existingNames = new Set(
    projectDocuments
      .filter(isRealDocument)
      .map((doc) => doc.rootDocumentName)
      .filter(Boolean)
  );

  const seen = new Set<string>();
  const inBatch = new Set<string>();
  newDocumentNames.forEach((name) => {
    if (seen.has(name)) inBatch.add(name);
    seen.add(name);
  });

  // One message per name: "already exists here" wins over "picked twice".
  return {
    inProject: Array.from(seen).filter((name) => existingNames.has(name)),
    inBatch: Array.from(inBatch).filter((name) => !existingNames.has(name)),
  };
};
